import Vue from 'vue'
import Router from 'vue-router'

import index from './components/pages/Index'
import remind_password from './components/pages/RemindPassword'
import remind_password_setting from './components/pages/RemindPasswordSetting'
import calendar from "./components/pages/Calendar";

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: "/",
			name: "index",
			component: index
		},
		{
			path: "/remind_password",
			name: "remind_password",
			component: remind_password
		},
		{
			path: "/remind_password_setting",
			name: "remind_password_setting",
			component: remind_password_setting
		},
		{
			path: "/calendar",
			name: "calendar",
			component: calendar
		},
	],
})
